import React, {useEffect, useState} from 'react';
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

// Add CSS for higher z-index to appear above modals and overlay background
if (typeof document !== 'undefined') {
    const styleId = 'confirm-dialog-zindex-fix';
    if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.innerHTML = `
            .react-confirm-alert-overlay {
                z-index: 1060 !important;
                background: rgba(0, 0, 0, 0.7) !important;
                display: flex !important;
                justify-content: center !important;
                align-items: flex-end !important;
                padding-bottom: 20px !important;
            }
            .overlay-custom-class-name {
                z-index: 1060 !important;
                background: rgba(0, 0, 0, 0.7) !important;
                display: flex !important;
                justify-content: center !important;
                align-items: flex-end !important;
                padding-bottom: 20px !important;
            }
            .react-confirm-alert-body {
                width: 100% !important;
                display: flex !important;
                justify-content: center !important;
            }
        `;
        document.head.appendChild(style);
    }
}

const ConfirmUI = ({title, message, onClose, onYes, onNo}) => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(() => {
        // Check for dark mode attribute on html tag
        const checkDarkMode = () => {
            const theme = document.documentElement.getAttribute('data-bs-theme');
            setIsDarkMode(theme === 'dark');
        };

        checkDarkMode();

        // Optional: Listen for mutations if theme changes dynamically without reload
        const observer = new MutationObserver(checkDarkMode);
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bs-theme'] });

        return () => observer.disconnect();
    }, []);

    const styles = {
        card: isDarkMode ? {
            backgroundColor: '#1e1e2d',
            color: '#a1a5b7',
            border: 'none'
        } : {
            backgroundColor: '#ffffff',
            border: 'none'
        },
        actionBtn: isDarkMode ? {
            backgroundColor: '#252536',
            borderColor: '#2b2b40',
            color: '#a1a5b7'
        } : {
            backgroundColor: '#f9f9f9',
            color: '#3f4254'
        },
        cancelBtn: isDarkMode ? {
            backgroundColor: '#2b2b40',
            color: '#a1a5b7'
        } : {
            backgroundColor: '#f5f8fa',
            color: '#7e8299'
        },
        title: isDarkMode ? { color: '#ffffff' } : { color: '#181c32' },
        text: isDarkMode ? { color: '#a1a5b7' } : { color: '#7e8299' }
    };

    return (
        <div className="card shadow-lg rounded-4" style={{
            maxWidth: '500px',
            width: '95vw',
            zIndex: 9999,
            ...styles.card
        }}>
            {/* Handle Bar */}
            <div className="d-flex justify-content-center pt-4 pb-2">
                <div className="rounded-pill" style={{
                    width: '40px',
                    height: '4px',
                    backgroundColor: isDarkMode ? '#474761' : '#e4e6ef'
                }}></div>
            </div>

            <div className="card-body text-center pt-2 pb-6 px-6">
                <h3 className="fw-bolder mb-3 fs-3" style={styles.title}>{title}</h3>
                <p className="mb-8 fs-5 fw-semibold" style={styles.text}>{message}</p>

                {/* Yes Button (Action Style) */}
                <button
                    className="d-flex align-items-center justify-content-between p-4 w-100 mb-4 rounded-3 border-0 cursor-pointer text-hover-primary"
                    style={{
                        ...styles.actionBtn,
                        transition: 'all 0.2s ease'
                    }}
                    onClick={onYes}
                >
                    <div className="d-flex align-items-center">
                        <div className="symbol symbol-40px me-4">
                            <div className="symbol-label bg-light-primary">
                                <i className="bi bi-check-lg text-primary fs-2"></i>
                            </div>
                        </div>
                        <span className="fw-bold fs-6 text-start">
                            Yes, proceed
                        </span>
                    </div>
                    <i className="bi bi-chevron-right fs-4 text-gray-500"></i>
                </button>

                {/* No Button (Cancel Style) */}
                <button
                    className="btn w-100 py-3 fw-bold fs-6"
                    style={styles.cancelBtn}
                    onClick={onNo}
                >
                    Cancel
                </button>
            </div>
        </div>
    );
};

export function showConfirmDialog(description) {
    return new Promise((resolve) => {
        const options = {
            title: 'Are you sure?',
            message: description,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => resolve(true)
                },
                {
                    label: 'No',
                    onClick: () => resolve(false)
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            overlayClassName: 'overlay-custom-class-name',
            customUI: ({ title, message, onClose }) => (
                <ConfirmUI
                    title={title}
                    message={message}
                    onClose={onClose}
                    onYes={() => {
                        resolve(true);
                        onClose();
                    }}
                    onNo={() => {
                        resolve(false);
                        onClose();
                    }}
                />
            )
        };

        confirmAlert(options);
    });
}


